<template>
  <div>
    <v-card>
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <div>
                <v-row
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  justify="center"
                  :style="
                    $vuetify.breakpoint.smAndDown
                      ? { marginTop: '5%' }
                      : $vuetify.breakpoint.mdAndDown
                      ? { marginTop: '5%' }
                      : { marginTop: '3%' }
                  "
                >
                  <v-icon @click="BackToManagePreRegister()" size="45"
                    >mdi-arrow-left-bold-circle-outline</v-icon
                  >&nbsp;
                  <p
                    style="
                      text-align: center;
                      font-size: 22px;
                      color: #14223c;
                      padding-top: 1rem;
                    "
                  >
                    {{ $t("message.PreRegister") }}
                  </p>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-card flat>
                      <v-card-text>
                        <v-row cols="12" md="12" justify="center">
                          <v-col cols="12" md="3">
                            <v-text-field
                              :placeholder="$t('message.GuestInviteName')"
                              :label="$t('message.GuestInviteName')"
                              v-model="VisitorName"
                              type="text"
                              outlined
                              dense
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              :items="FloorList"
                              item-text="floorName"
                              item-value="locationID"
                              :label="$t('message.SelectFloor')"
                              v-model="Floor"
                              dense
                              outlined
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center">
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="menuStartDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="StartDateDisplay"
                                  :label="$t('message.StartDate')"
                                  append-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="StartDate"
                                :min="today"
                                @change="menuStartDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu
                              ref="menuStartTime"
                              v-model="menuStartTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="StartTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="StartTime"
                                  :label="$t('message.StartTime')"
                                  append-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  outlined
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menuStartTime"
                                v-model="StartTime"
                                full-width
                                format="24hr"
                                @click:hour="onSelectHour"
                                @click:minute="
                                  $refs.menuStartTime.save(EndTime)
                                "
                                :allowed-hours="allowedHours"
                                :allowed-minutes="allowedMinutes"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center">
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="menuEndDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="EndDateDisplay"
                                  :label="$t('message.EndDate')"
                                  append-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="EndDate"
                                :min="today"
                                @change="menuEndDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu
                              ref="menuEndTime"
                              v-model="menuEndTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="EndTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="EndTime"
                                  :label="$t('message.EndTime')"
                                  append-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  outlined
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menuEndTime"
                                v-model="EndTime"
                                full-width
                                format="24hr"
                                @click:hour="onSelectEndHour"
                                @click:minute="$refs.menuEndTime.save(EndTime)"
                                :allowed-hours="allowedEndHours"
                                :allowed-minutes="allowedEndMinutes"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center">
                          <v-col cols="12" md="6">
                            <v-textarea
                              v-model="Remark"
                              :label="$t('message.Remark')"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          justify="center"
                        >
                          <v-col cols="12" md="4" align="center">
                            <v-btn
                              style="color: white"
                              height="40"
                              width="150"
                              color="green"
                              @click="inviteVisitor()"
                            >
                              {{ $t("message.Submit") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "PreRegister",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRvalue: "",
      QRsize: 250,
      Username: this.$cookies.get("Username"),
      FloorList: [],
      StartDate: "",
      EndDate: "",
      menuStartDate: false,
      menuEndDate: false,
      StartTime: null,
      menuStartTime: false,
      EndTime: null,
      menuEndTime: false,
      VisitorName: "",
      Floor: null,
      Remark: "",
      today: new Date().toISOString().substr(0, 10),
    };
  },

  computed: {
    StartDateDisplay() {
      if (!this.StartDate) return "";
      let [year, month, day] = this.StartDate.split("-");
      return `${day}-${month}-${year}`;
    },
    EndDateDisplay() {
      if (!this.EndDate) return "";
      let [year, month, day] = this.EndDate.split("-");
      return `${day}-${month}-${year}`;
    },
  },

  async mounted() {
    let self = this;
    self.getDataAuthorizeFloor();
  },

  methods: {
    allowedHours(hour) {
      const now = new Date();
      const currentHour = now.getHours();
      if (this.StartDate !== this.today) {
        return true;
      }
      return hour >= currentHour;
    },

    onSelectHour(h) {
      this.EndTime = `${h.toString().padStart(2, "0")}:00`;
    },

    allowedMinutes(minute) {
      if (!this.StartTime) return true;
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const selectedHour = parseInt(this.StartTime.split(":")[0], 10);
      if (this.StartDate !== this.today) {
        return true;
      }
      if (selectedHour === currentHour) {
        return minute > currentMinute;
      }
      return true;
    },

    allowedEndHours(hour) {
      const now = new Date();
      const currentHour = now.getHours();
      const [startHour] = this.StartTime ? this.StartTime.split(":") : [null];
      if (this.EndDate !== this.today) {
        if (startHour !== null && hour < parseInt(startHour)) {
          return false;
        }
        return true;
      }
      if (hour < currentHour) {
        return false;
      }
      if (startHour !== null && hour < parseInt(startHour)) {
        return false;
      }
      return true;
    },

    onSelectEndHour(h) {
      this.EndTime = `${h.toString().padStart(2, "0")}:00`;
    },

    allowedEndMinutes(minute) {
      if (!this.EndTime) return true;
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const [startHour, startMinute] = this.StartTime
        ? this.StartTime.split(":").map(Number)
        : [null, null];

      const [selectedHour] = this.EndTime.split(":").map(Number);
      if (this.EndDate !== this.today) {
        if (selectedHour === startHour && minute <= startMinute){
          return false;
        }
        if (selectedHour < startHour){
          return false;
        }
        return true;
      }
      if (selectedHour === currentHour) {
        if (minute <= currentMinute){
          return false;
        } 
      }
      if (selectedHour === startHour) {
        if (minute <= startMinute) {
          return false;
        }
      }
      if (selectedHour < startHour) {
        return false;
      }
      return true;
    },

    getDataAuthorizeFloor() {
      let self = this;
      axios
        .get(`${self.url}User/AuthorizeFloor`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.FloorList = response.data.data;
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: message,
          });
        });
    },

    inviteVisitor() {
      let self = this;
      if (
        self.visitorName == "" ||
        self.StartDate == "" ||
        self.StartTime == "" ||
        self.EndDate == "" ||
        self.EndTime == "" ||
        self.Floor == "" ||
        self.Floor == null
      ) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณากรอกข้อมูลผู้มาติดต่อให้ครบถ้วน !",
        });
      } else if (self.EndTime <= self.StartTime) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "วันที่และเวลาสิ้นสุดต้องไม่อยู่ก่อนวันที่และเวลาเริ่มต้น !",
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          visitorName: self.VisitorName,
          startDate: self.StartDate,
          endDate: self.EndDate,
          startTime: self.StartTime,
          endTime: self.EndTime,
          locationID: self.Floor,
          remark: self.Remark,
        };
        axios
          .post(`${self.url}PreRegister/Invite`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.$router.push({ name: "ManagePreRegister" });
            }
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    BackToManagePreRegister() {
      let self = this;
      self.$router.push("/ManagePreRegister");
    },
  },
};
</script>
<style scoped>
</style>
    